import HOPRichTextEditor from '@/shared/components/HOPComponents/HOPRichTextEditor/HOPRichTextEditor'
import SDButton from '@/shared/components/SDComponents/SDButton/SDButton'
import SDNotification from '@/shared/components/SDComponents/SDNotification'
import { useTranslation } from 'react-i18next'
import { DatePicker } from 'baseui/datepicker'
import { SIZE } from 'baseui/input'
import useFormationForm from './useFormationForm'

const FormationForm = () => {
  const { t } = useTranslation()
  const {
    speedFormation,
    editorRef,
    pickerDate,
    minDueDate,
    changeDate,
    hasDueDate,
    setIsEditing,
    saveSpeedFormation,
    isLoading,
    error,
    errorMessage,
  } = useFormationForm()

  return (
    <>
      <HOPRichTextEditor
        id='speed-formation-text-input'
        ref={editorRef}
        initialValue={speedFormation.text}
        height={250}
      />
      <div hidden={!hasDueDate}>
        <DatePicker
          size={SIZE.compact}
          formatString='dd/MM/yyyy'
          minDate={minDueDate}
          maxDate={null}
          value={pickerDate}
          onChange={changeDate}
        />
      </div>
      <SDButton id='speed-formation-cancel-button' onClick={() => setIsEditing(false)}>
        {t('common:cancel')}
      </SDButton>
      <SDButton id='speed-formation-save-button' onClick={saveSpeedFormation} isLoading={isLoading}>
        {t('common:save')}
      </SDButton>
      {error && errorMessage && <SDNotification type={'warning'}>{errorMessage}</SDNotification>}
    </>
  )
}

export default FormationForm
